import { useRouter } from 'next/router';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import CloudinaryImage from '../common/CloudinaryImage';

export default function BlogImage({
  image_url = '',
  height = '100%',
  width = '100%',
  dataAlt,
  alternativeText = '',
  index,
}) {
  const { asPath } = useRouter();

  let imgURL = asPath === `/blog/`;
  let homeimgURL = asPath === `/`;
  let industriesimgURL = asPath === `/industries/`;

  return imgURL ? (
    <div
      className={`${index % 2 !== 0 && 'lg:h-[350px]'} lg:h-[280px] overflow-hidden blog-img lg:rounded-[40px] rounded-[20px]`}
    >
      {image_url?.length === 0 ? (
        <Skeleton height={height} width={width} style={{ zIndex: 0 }} />
      ) : (
        <CloudinaryImage
          backendImgUrl={image_url}
          className="w-[100%] h-[100%] transition-custom9 group-hover:scale-105 lg:rounded-[40px] rounded-[20px] transition-all object-cover"
          alt={alternativeText || dataAlt}
          type="smallimg"
        />
      )}
    </div>
  ) : homeimgURL ? (
    <div className="md:h-[280px] overflow-hidden">
      <CloudinaryImage
        backendImgUrl={image_url}
        className="w-[100%] h-auto lg:rounded-[40px] rounded-[20px] group-hover:scale-110 "
        width={100}
        alt={alternativeText || dataAlt}
        type="smallimg"
      />
    </div>
  ) : industriesimgURL ? (
    <div className="h-[280px] overflow-hidden">
      <CloudinaryImage
        backendImgUrl={image_url}
        className="w-[100%] h-[100%] lg:rounded-[40px] rounded-[20px] group-hover:scale-110"
        alt={alternativeText || dataAlt}
        type="smallimg"
      />
    </div>
  ) : (
    <CloudinaryImage
      backendImgUrl={image_url}
      className="w-[100%] h-[100%] lg:h-[280px] lg:rounded-[40px] rounded-[20px] object-cover"
      alt={alternativeText || dataAlt}
      type="smallimg"
    />
  );
}
